import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';

import styles from './UnsavedChangesPopup.module.scss';

interface UnsavedChangesPopupProps {
  onStay: () => void;
  onLeave: () => void;
}

const UnsavedChangesPopup: React.FC<UnsavedChangesPopupProps> = ({ onStay, onLeave }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <h2>{t('floorplan.unsavedChanges.title')}</h2>
        <p>{t('floorplan.unsavedChanges.description')}</p>
        <div className={styles.actions}>
          <Button variant="light" size="sm" onClick={onStay}>{t('floorplan.unsavedChanges.stay')}</Button>
          <Button variant="fill" size="sm" onClick={onLeave}>{t('floorplan.unsavedChanges.leave')}</Button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesPopup;
